import { configureStore, createSlice } from "@reduxjs/toolkit";

let state = {
    rates: {},
};

const userSlice = createSlice({
    name: "inclinic",
    initialState: state,
    reducers: {
        currencyRates: (state, payload = {}) => {
            state.rates = payload.payload;
        },
    },
});

const store = configureStore({
    reducer: {
        inclinic: userSlice.reducer,
    },
    devTools: false,
});

export const { currencyRates } = userSlice.actions;

export default store;
